module.exports = __webpack_public_path__ + "img/Payfast-Logo-DPO-Stacked.47674981.svg";